module.exports = {
	"de": {
		"models": {
			"duplicate_action": "Duplizieren",
			"edit_action": "Editieren",
			"delete_action": "Löschen",
			"auth": {
				"remember_me": "Für 7 Tage angemeldet bleiben"
			},
			"business_kit": {
				"action": "",
				"date": "Datum",
				"fail": "Das Versenden des Businesskits ist fehlgeschlagen",
				"id": "id",
				"name": "Name",
				"select": "BusinessKit",
				"sent": "Dein Businesskit wurde verschickt",
				"create_template": "Template erstellen",
				"status": {
					"email_sent": "Gesendet",
					"sendout_enqueued": "Gesendet",
					"transferred": "Übermittelt"
				},
				"missing": {
					"email": "Versenden fehlgeschlagen. Möglicherweise musst Du erst ein Businesskit-E-Mail-Template erstellen bevor Du dieses Businesskit verschicken kannst."
				}
			},
			"external_form": {
				"action": "Aktion",
				"configuration": "Konfiguration",
				"additional_data": "Erweiterte Daten",
				"email_recipient_address": "Schicke an",
				"id": "#",
				"language": "Sprache",
				"message": {
					"create": "Das Formular wurde erfolgreich erstellt",
					"update": "Das Formular wurde erfolgreich aktualisiert"
				},
				"name": "Name",
				"project_id": "Projekt",
				"project_name": "Projekt",
				"project__name": "Projekt",
				"slug": "ID",
				"structure": "Struktur",
				"title": "Formular Titel",
				"duplicate": "",
				"duplicate_desc": "Formular duplizieren",
				"duplicate_project_desc": "Projekt duplizieren"
			},
			"lead_mask": {
				"action": "Aktion",
				"default": "Standard Berichtsbogen?",
				"yes": "Ja",
				"no": "Nein",
				"id": "#",
				"language": "Sprache",
				"message": {
					"create": "Die Berichtsbogen wurde erfolgreich erstellt.",
					"update": "Die Berichtsbogen wurde erfolgreich aktualisiert."
				},
				"name": "Name",
				"project_id": "Projekt",
				"organization": "Organisation",
				"organization_name": "Organisation",
				"project": "Projekt",
				"slug": "Slug",
				"structure": "Struktur",
				"duplicate": "",
				"duplicate_desc": "Berichtsbogen duplizieren"
			},
			"opt-in": {
				"businesskit__name": "Businesskit Name",
				"id": "#",
				"project__name": "Projekt Name",
				"subdomain": "Subdomain",
				"template_name": "Template Name"
			},
			"organization": {
				"action": "",
				"action_delete": "",
				"city": "Stadt",
				"country": "Land",
				"id": "Id",
				"message": {
					"create": "Die Organisation wurde erfolgreich erstellt",
					"update": "Die Organisation wurde erfolgreich aktualisiert"
				},
				"name": "Name",
				"status": "",
				"street": "Straße",
				"street_number": "Hausnummer",
				"users__count": "Benutzer",
				"website": "Webseite",
				"zip": "PLZ"
			},
			"organizations": {
				"successfully_started_crm_sync": "CRM Synchronisation erfolgreich gestartet"
			},
			"project": {
				"action": "Aktion",
				"background_xml_export_enabled": "Leads App Synchronisation aktivieren",
				"base_score": "Basisbewertung",
				"business_kits_count": "Businesskits",
				"businesskit_to_assign": "Businesskit zuweisen",
				"enable_lead_review": "Aktiviere manuellen Review von Leads aus der Leads App",
				"scope_leads": "Benutzer können nur ihre eigenen Leads sehen",
				"category": "Kategorie",
				"crm_campaign_id": "CRM Kampagnen ID",
				"crm_sales_employee_id": "CRM Vertriebsmitarbeiter ID",
				"crm_marketing_employee_id": "CRM Marketingmitarbeiter ID",
				"crm_group_code_id": "CRM Gruppencode ID",
				"end_date": "Enddatum der Kampagne",
				"hot_leads_count": "Heiße Leads",
				"id": "#",
				"is_opt_in": "Ist Opt-In?",
				"lead_mask": "Berichtsbogen",
				"lead_mask_id": "Wähle einen vorhandenen Berichtsbogen aus",
				"leads_count": "Leads",
				"product": "Product",
				"leads_not_synced_count": "Pending Leads",
				"location": "Ort",
				"mailchimp_list_id": "Mailchimp-Liste ID",
				"message": {
					"create": "Das Projekt wurde erfolgreich erstellt",
					"update": "Das Projekt wurde erfolgreich aktualisiert"
				},
				"name": "Name",
				"organization": "Organisation",
				"organization_name": "Organisation",
				"period": "Zeitraum",
				"set_aditional_data_content": "Zusätzliche Daten anzeigen und einstellen",
				"start_date": "Startdatum der Kampagne",
				"sync_disabled": "CRM Syncronisation",
				"unsynced_leads_count": "Sync Status",
				"user_to_assign": "Benutzer zuweisen",
				"unsynced_leads_count_success": "Synchronisiert",
				"duplicate": "",
				"default_classification": "Standard-Klassifizierung",
				"business_kit_id": "Businesskits",
				"project_label": "Projekt-Label"
			},
			"project_lead": {
				"academic_title": "Titel",
				"action": "Aktion",
				"advancement": "Fortschritt",
				"branch": "Zielgruppe",
				"business_card_job_title": "Job-Titel",
				"capturer": "Erfasser",
				"capturer_unknown": "Nicht zugeordnet",
				"city": "Stadt",
				"classification": "Klassifizierung",
				"company": "Firma",
				"company-name": "Firmenname",
				"company_department": "Abteilung",
				"company_function": "Funktion",
				"company_role": "Rolle",
				"company_website": "Firmen-Webseite",
				"conversation_notes": "Notizen",
				"country": "Land",
				"crawled_infos": {
					"by": "von",
					"founded": "Gegründet",
					"linkedin": "LinkedIn Profil",
					"more_infos": "Mehr Informationen",
					"phone_number": "Telefonnummer",
					"tags": "Tags",
					"title_website": "Titel der Webseite",
					"tweets": "Tweets",
					"category": "Kategoien",
					"description": "Beschreibung",
					"domain": "Webseite",
					"emailAddresses": "E-Mails",
					"foundedYear": "Gegründet",
					"location": "Location",
					"metrics": "Metrics",
					"name": "Firmenname",
					"phoneNumbers": "Telefonnummern"
				},
				"found_existing": "Wir haben bereits existierende Daten für diesen Lead gefunden und diese übernommen.",
				"predicted_name": "Basierend auf der E-Mail Adresse konnten wir bereits Daten zum Kontakt ermitteln.",
				"created": "Der Lead wurde erfolgreich erstellt.",
				"created_at": "Erstellt",
				"email": "E-Mail",
				"exhibition_visitor_count": "Anzahl Messebesucher",
				"firstname": "Vorname",
				"full_street": "Straße & Nr",
				"gender": "Anrede",
				"id": "#",
				"import_origin": "",
				"interested_in": "Interessiert an",
				"kit_status": "",
				"language": "Sprache",
				"lastname": "Nachname",
				"message": {
					"changes_pending": "Es gibt Änderungen. Zuletzt gespeichert",
					"changes_saved": "Letzte Änderungen:",
					"create": "Der Lead wurde erfolgreich erstellt",
					"create_from_card": "Visitenkarte scannen",
					"create_from_email": "E-Mail Adresse eintragen",
					"leads_exists": "Der Lead existiert bereits aber er wurde zum aktuellen Projekt hinzugefügt",
					"no_business_card": "Keine Visistenkarte hochgeladen",
					"update": "Der Lead wurde erfolgreich aktualisiert"
				},
				"name": "Name",
				"origin": "",
				"phone_company": "Firmen-Telefon",
				"phone_mobile": "Mobiltelefon",
				"progress_complete": "Alle Pflichtfelder wurden ausgefüllt",
				"progress_indicator_businesskit": "Fortschritt",
				"progress_indicator_crm": "Status",
				"progress_indicator_lead_mask": "Status",
				"project_planned": "Projekt geplant",
				"salutation": "Ansprasche",
				"start_date": "Erstellt am",
				"status": "Status",
				"street": "Straße",
				"street_number": "Nummer",
				"sync_disabled": "CRM Sync",
				"sync_status": "CRM",
				"sync_statuses": {
					"no_crm": "Kein CRM konfiguriert",
					"no_crm_desc": "Die Organisation hat kein CRM konfiguriert",
					"not_sync_ready": "Nicht bereit",
					"not_sync_ready_desc": "Der Lead hat nicht alle für den CRM Sync notwendigen Felder ausgefüllt",
					"not_synced": "Nicht synchronisiert",
					"not_synced_desc": "Der Lead wurde aus dem CRM importiert aber noch nicht bearbeitet.",
					"processing": "Synchronisiere",
					"processing_desc": "Der Lead synchronisiert gerade",
					"sync_disabled": "Deaktiviert",
					"sync_disabled_desc": "Der Lead ist bereit zum Synchronisieren aber die Lead Synchronisation ist deaktiviert",
					"sync_error": "Fehler",
					"sync_error_desc": "Die Lead Synchronisation hat zu einem Fehler geführt",
					"sync_ready": "Bereit",
					"sync_ready_desc": "Der Lead ist bereit zum Synchronisieren",
					"synced": "Synchronisiert",
					"synced_desc": "Der Lead wurde synchronisiert"
				},
				"title": "Titel",
				"updated_at": "Letzte Bearbeitung",
				"user_id": "Lead-Erfasser",
				"zip": "PLZ",
				"import_origins": {
					"crm": "Vom CRM importiert"
				},
				"origins": {
					"mobile_app": "Via App",
					"web_app": "Via Cloud"
				},
				"sync_missing_fields": "Unvollständige Werte:"
			},
			"select_role": {
				"user": "Standard Benutzer",
				"admin": "Administrator"
			},
			"select_status": {
				"pre_review": "Pre Review",
				"review": "Überarbeitung",
				"active": "Akzeptiert"
			},
			"select_academic_title": {
				"ba": "Ba",
				"dr": "Dr",
				"mba": "MBA",
				"phd": "PhD",
				"prof": "Prof.",
				"prof_dr": "Prof. Dr."
			},
			"select_background_xml_export_enabled": {
				"false": "Nein",
				"no": "Nein",
				"true": "Ja",
				"yes": "Ja"
			},
			"select_branch": {
				"automotive": "Automotive",
				"culture": "Kultur",
				"education": "Bildung",
				"electronics": "Electronil",
				"event": "Event",
				"finance": "Finanzen",
				"food": "Gastro",
				"health": "Gesundheit",
				"import": "Import",
				"insurance": "Versicherungen",
				"it": "IT",
				"law": "Recht",
				"marketing": "Marketing",
				"non_profit": "Non profit",
				"other": "Andere",
				"print": "Druck",
				"public": "Öffentlicht",
				"real_estate": "Real estate",
				"service": "Service"
			},
			"select_category": {
				"exhibition": "Messe",
				"inbound": "Inbound",
				"other": "Andere"
			},
			"select_scope": {
				"organization": "Organisation",
				"project": "Projekt"
			},
			"select_frequency": {
				"daily": "Täglich",
				"immediately": "Stündlich",
				"once": "Nur einmal"
			},
			"select_classification": {
				"cold": "Kalt",
				"hot": "Heiß",
				"warm": "Warm",
				"unclassified": "–"
			},
			"select_default_classification": {
				"cold": "Kalt",
				"hot": "Heiß",
				"warm": "Warm",
				"unclassified": "–"
			},
			"select_company_department": {
				"finance": "Finanzen",
				"human_resources": "Human Resources",
				"it": "IT",
				"marketing": "Marketing",
				"other": "Andere",
				"sales": "Verkauf",
				"secretariat": "Sekretariat",
				"service_management": "Service Management"
			},
			"select_company_function": {
				"CEO": "Vorstandschef",
				"consultant": "Berater",
				"head_of": "Abteilungsleiter",
				"manager": "Manager",
				"managing_director": "Geschäftsführung",
				"other": "Other",
				"person_in_charge": "Sachbearbeiter"
			},
			"select_company_role": {
				"decision_maker": "Entscheider",
				"decision_maker_budget": "Entscheider mit Budget",
				"non_decision_maker": "Kein Entscheider",
				"other": "Andere"
			},
			"select_gender": {
				"female": "Weiblich",
				"male": "Männlich",
				"undefined": "-"
			},
			"select_importOrigin": {
				"crm": "CRM",
				"xls": "XLS"
			},
			"select_interested_in": {
				"meeting": "Meeting",
				"other": "Andere",
				"presentation": "Präsentation",
				"pricing": "Preise",
				"product_informations": "Produkt Information"
			},
			"select_is_opt_in": {
				"false": "Nein",
				"no": "Nein",
				"true": "Ja",
				"yes": "Ja"
			},
			"select_language": {
				"de": "Deutsch",
				"en": "Englisch"
			},
			"select_origin": {
				"mobile_app": "Lead App",
				"opt_in_email": "Opt-in email",
				"opt_in_linked_in": "Opt-in linkedin",
				"opt_in_xing": "Opt-in xing",
				"web_app": "Cloud",
				"external_form": "External Form"
			},
			"select_project_planned": {
				"0-3months": "0-3 Monate",
				"3-6months": "3-6 Monate",
				"6-12months": "6-12 Monate",
				"no_plan": "Nichts geplant"
			},
			"select_sync_disabled": {
				"false": "Aktiviert",
				"no": "Aktiviert",
				"true": "Deaktiviert",
				"yes": "Deaktiviert"
			},
			"select_sync_status": {
				"no_crm": "Kein CRM",
				"not_sync_ready": "Nicht 100%",
				"not_synced": "Unbearbeitet",
				"processing": "Gestartet",
				"sync_error": "Fehler",
				"sync_ready": "100%",
				"synced": "Erfolgreich"
			},
			"tracking": {
				"activity": "Ereignis",
				"date": "Datum",
				"kit": "Kit",
				"specific": {
					"confirm_redeem_coupon": "Klick auf Einlöse-Button",
					"click_event_pdf": "Klick auf Businesskit PDF",
					"cta_coupon": "Klick auf Content CTA",
					"embed_visit_url": "Webseite URL tracking",
					"open_bag": "Businesskit geöffnet",
					"view_coupon": "Inhalt angesehen",
					"view_website": "CTA geklickt",
					"view_website_coupon": "Klick auf 'Webseite ansehen'",
					"visit_website": "Webseite besucht",
					"toggle_event_info": "Klick auf Businesskit Mehr Informationen"
				}
			},
			"plan": {
				"id": "ID",
				"name": "Name",
				"price": "Preis",
				"organizations_count": "Organisationen",
				"action": "Actions",
				"max_users": "Maximale Benutzer",
				"max_admins": "Maximale Admins",
				"max_businesskits": "Maximale Businesskits",
				"message": {
					"update": "Plan erfolgreich aktualisiert"
				},
				"allowed_forms": "Formulare erlaubt",
				"allowed_statistics": "Statistiken erlaubt",
				"allowed_custom_leadsheets": "Angepasste Berichtsbögen erlaubt",
				"allowed_email_templates": "Angepasste E-Mail Templates erlaubt",
				"allowed_clearbit": "Clearbit Benutzung erlaubt",
				"allowed_crm": "CRM Nutzung erlaubt",
				"allowed_api": "API Nutzung erlaubt",
				"allowed_eb_whitelabel": "Benutzerdefiniertes eventbaxx Whitelabel erlaubt",
				"allowed_lead_pdf_download": "PDF Download für Leads erlaubt"
			},
			"user": {
				"action": "Aktion",
				"email": "E-Mail",
				"firstname": "Vorname",
				"id": "id",
				"invite-role": "Rolle",
				"lastname": "Nachname",
				"fullname": "Voller Name",
				"edit_user": "Benutzer bearbeiten",
				"role": "Rolle",
				"message": {
					"create": "Der Benutzer wurde erfolgreich erstellt",
					"update": "Der Benutzer wurde erfolgreich aktualisisert"
				},
				"organization_id": "Organisation",
				"organization": "Organisation",
				"organization_name": "Organisation",
				"password": "Passwort",
				"status": "Status",
				"created_at": "Datum",
				"name": "Name",
				"statuses": {
					"active": "Akzeptiert",
					"confirmed": "Akzeptiert",
					"inactive": "Inaktiv",
					"unconfirmed": "Unbestätigt",
					"pending": "Pending",
					"review": "Überarbeitung",
					"pre_review": "Pre Review"
				}
			},
			"select_type": {
				"title_h1": "H1 Titel",
				"title_h2": "H2 Titel",
				"title_h3": "H3 Titel",
				"title_h4": "H4 Titel",
				"image": "Bild",
				"paragraph": "Paragraph",
				"hidden": "Hidden field",
				"text": "Text field",
				"textarea": "Textarea",
				"select": "Select field",
				"radio": "Radio field",
				"radio_custom": "Radio custom field",
				"checkbox": "Checkbox field",
				"checkbox_custom": "Checkbox custom field",
				"country_select": "Country select field",
				"confirmation": "Confirmation field",
				"free_drawing": "Zeichnung",
				"submit": "Submit",
				"container": "Container",
				"container_grid": "Grid container",
				"container_top": "Container top",
				"container_bottom": "Container bottom",
				"container_tab": "Container tab",
				"crawled_infos": "Crawled Infos"
			},
			"email_template": {
				"id": "",
				"name": "Name",
				"language": "Sprache",
				"action": "Aktion",
				"organization": "Organisation",
				"body": "Inhalt",
				"salutation": "Ansprache",
				"salutation_fallback": "Fallback Ansprache",
				"from": "E-Mail Von",
				"reply_to": "Antwort an",
				"imprint_url": "Impressum URL",
				"privacy_url": "Datenschutz URL",
				"primary_color": "Primärfarbe",
				"message": {
					"create": "Das E-Mail Template wurde erfolgreich erstellt.",
					"update": "Das E-Mail Template wurde erfolgreich aktualisiert."
				},
				"duplicate": "",
				"duplicate_desc": "E-Mail Template duplizieren"
			},
			"organization_configuration": {
				"api_token_eventbaxx": "Eventbaxx api token",
				"enrichment_disabled": "Clearbit enrichment",
				"mailchimp_api_key": "Mailchimp api key",
				"ranking_display": "Zeige das Lead-Hunter Ranking?",
				"xing_consumer_key": "Xing consumer key",
				"eventbaxx_auth_token": "Eventbaxx authentication key"
			},
			"workflow": {
				"id": "ID",
				"name": "Name",
				"status": "Status",
				"last_execution": "Letzte Ausführung",
				"frequency": "Frequenz",
				"first_run": "Erste Ausführung (UTC)",
				"final_run": "Finale Ausführung (UTC)",
				"daily_runtime": "Uhrzeit (UTC)",
				"action": "Aktion",
				"project": "Projekt",
				"project_name": "Projekt",
				"execute_on": "Bedingung",
				"configuration": "Konfiguration",
				"scope": "Berücksichtige Leads aus:",
				"loading_projects": "Projekte werden geladen…",
				"message": {
					"create": "Workflow erfolgreich erstellt",
					"trigger_success": "Workflow erfolgreich ausgeführt",
					"update": "Workflow erfolgreich aktualisiert"
				},
				"collection": {
					"frequency": {
						"daily": "Täglich",
						"immediately": "Stündlich",
						"once": "Einmalig",
						"undefined": "–"
					}
				}
			}
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./hileadzz_i18n/hileadzz/models.de.yml
// module id = 2028
// module chunks = 0